<template lang="pug">
  footer.appFooter
    ul.appFooter__links.footerLinks
      li
        a(href="https://www.doublejump.tokyo/" target="_blank")
          lazy-image(:src="`${this.$env.cdnUrl}/static/icon/DJT_logo.png`" width="28" height="28" alt="doublejump.tokyo")
      li.bigImg
        a(href="https://www.blockchaincontents.org/" target="_blank")
          lazy-image(src="~/assets/images/BCC.png" width="28" height="28" alt="MCHplus")
      li
        a.discordcolor(href="https://discord.gg/X5kuKdc" target="_blank")
          fa-icon(:icon="['fab', 'discord']" size="2x")
      li
        a.twittercolor(:href="$i18n.locale === 'ja' ? 'https://twitter.com/bfheroes_pr' : 'https://twitter.com/bfh_global'" target="_blank")
          fa-icon(:icon="['fab', 'x-twitter']" size="2x")
      //- li(v-if="$i18n.locale === 'ja'")
      //-   a(href='https://gaudiy.com/signup/r3fc6yD5qfAfirbfN6MN' target="_blank")
      //-     img(:src="$env.staticUrl+'/lp/img/top/gaudiy_icon.png'")
    p.appFooter__copyright
      //- small &copy; {{ `2018-${$dayjs().format('YYYY')}` }}
      small &copy; double jump.tokyo Inc. / &copy; Alim Co., Ltd.
</template>

<script>
const LazyImage = () => import('@/components/atoms/LazyImage')

export default {
  components: { LazyImage },
}
</script>

<style lang="scss" scoped>
.appFooter {
  display: grid;
  font-size: 0.8rem;
  grid-gap: 0.5rem;
  padding: 1rem;
  text-align: center;
  width: 100%;
  background-color: #1d1e21;

  @media (min-width: $breakpoint) {
    font-size: 1rem;
    grid-gap: 1rem;
    padding: 2rem;
  }

  &__copyright {
    display: grid;
    font-size: 10px;
    grid-gap: 0.5rem;
    grid-template-columns: auto auto;
    justify-content: center;

    small {
      color: $color-primary-lignt;
      font-size: inherit;
    }
  }
}

.footerLinks {
  /*align-items: center;
  color: $color-primary-lignt;
  display: grid;
  grid-template-columns: repeat(3, auto);
  grid-gap: 2rem;
  justify-content: center;
  list-style-type: none;
  padding: 0;*/
  padding: 0;
  margin: 0 auto;
  list-style-type: none;
  text-align: center;
  display: table;

  @media (min-width: $breakpoint) {
    /*grid-gap: 3rem;*/
  }

  li {
    display: table-cell;
    vertical-align: middle;
    width: 3rem;
    @media (min-width: $breakpoint) {
      width: 5rem;
    }
  }

  a {
    color: $color-primary-lignt;
  }

  img {
    height: auto;
    width: 28px;

    @media (min-width: $breakpoint) {
      width: 40px;
    }
  }

  .bigImg {
    img {
      width: 55px;
    }
  }
}

.discordcolor {
  color: #7288da !important;
}

.twittercolor {
  color: #ffffff !important;
}

.faceBookColor {
  color: #3b5998 !important;
}
</style>
